import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);

  const { investment: data } = await sdk.getOneInvestment({
    id,
  });
  return { data };
}

export const investmentCustomAnalytics = types.dataProvider({
  getOne,
});
